<script>
import Color from 'color'

export default {
  name: 'avatarContourA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    convertColor(hex) {
      return Color(hex)
    },
  },
}
</script>

<template>
  <fragment>
    <g
      id="Contour_A-1-5-3_Skin_Color_01"
      v-if="data.contour.value === 'type-1'"
    >
      <g>
        <g>
          <ellipse
            :fill="data.skin.value"
            cx="224.63"
            cy="184.69"
            rx="22.5"
            ry="19.7"
            transform="translate(12.55 383.66) rotate(-82.6)"
          />
          <ellipse
            :fill="data.skin.value"
            cx="94.69"
            cy="184.68"
            rx="19.7"
            ry="22.5"
            transform="translate(-23 13.73) rotate(-7.4)"
          />
          <ellipse
            isolation="isolate"
            opacity=".1"
            cx="224.63"
            cy="184.69"
            rx="22.5"
            ry="19.7"
            transform="translate(12.55 383.66) rotate(-82.6)"
          />
          <ellipse
            isolation="isolate"
            opacity=".1"
            cx="94.69"
            cy="184.68"
            rx="19.7"
            ry="22.5"
            transform="translate(-23 13.73) rotate(-7.4)"
          />
          <g>
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
        </g>
        <g id="wall-12">
          <path
            :fill="data.skin.value"
            d="m92.81,194.13c-.47-1.99-1.57-15.72-3.46-28.1-1.44-9.43-1.26-17.33-1.5-19.79-2.19-22.44-.73-86.42,71.55-86.42s73.74,63.98,71.55,86.42c-.26,2.64-.09,10.69-1.81,20.47-2.16,12.32-3.65,25.65-4.15,27.41-4.27,15.03-23.22,55.43-65.59,55.43s-62.62-38.75-66.59-55.43h0Z"
          />
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-5-2_Skin_Color_01"
      v-if="data.contour.value === 'type-2'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-11">
            <path
              :fill="data.skin.value"
              d="m90.81,192.13c-.47-1.99-1.57-13.72-3.46-26.1-1.44-9.43-2.26-17.33-2.5-19.79-2.19-22.44,2.27-86.42,74.55-86.42s77.74,63.98,75.55,86.42c-.26,2.64-1.09,10.69-2.81,20.47-2.16,12.32-3.65,23.65-4.15,25.41-4.27,15.03-23.65,55.43-68.59,55.43s-64.62-38.75-68.59-55.43h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-5-1_Skin_Color_01"
      v-if="data.contour.value === 'type-3'"
    >
      <g>
        <g>
          <ellipse
            cx="224.64"
            cy="184.68"
            rx="22.5"
            ry="19.7"
            transform="translate(12.56 383.67) rotate(-82.6)"
            :fill="data.skin.value"
          />
          <ellipse
            cx="94.69"
            cy="184.68"
            rx="19.7"
            ry="22.5"
            transform="translate(-23 13.73) rotate(-7.4)"
            :fill="data.skin.value"
          />
          <path
            d="M175.99,250.95c-1.56-.78-3.62-2.04-4.36-2.99-1.71-2.2-1.69-5.82-1.21-9.84,.77-6.47-4.41-12.2-11.11-12.07-6.7-.12-11.88,5.6-11.11,12.07,.48,4.02,.5,7.64-1.21,9.84-.85,1.05-2.8,2.19-4.14,2.86-23.53,31.99,53.34,34.52,33.13,.13Z"
            :fill="data.skin.value"
          />
          <ellipse
            cx="224.64"
            cy="184.68"
            rx="22.5"
            ry="19.7"
            transform="translate(12.56 383.67) rotate(-82.6)"
            :fill="convertColor(cornsilk)
                .darken(0.8)
                .hex()
            "
            opacity=".1"
          />
          <ellipse
            cx="94.69"
            cy="184.68"
            rx="19.7"
            ry="22.5"
            transform="translate(-23 13.73) rotate(-7.4)"
            :fill="convertColor(cornsilk)
                .darken(0.8)
                .hex()
            "
            opacity=".1"
          />
          <path
            d="M175.99,250.95c-1.56-.78-3.62-2.04-4.36-2.99-1.71-2.2-1.69-5.82-1.21-9.84,.77-6.47-4.41-12.2-11.11-12.07-6.7-.12-11.88,5.6-11.11,12.07,.48,4.02,.5,7.64-1.21,9.84-.85,1.05-2.8,2.19-4.14,2.86-23.53,31.99,53.34,34.52,33.13,.13Z"
            :fill="convertColor(cornsilk)
                .darken(0.8)
                .hex()
            "
            opacity=".1"
          />
        </g>
        <g id="wall-10">
          <path
            d="M86.81,192.13c-.47-1.99-1.57-13.72-3.46-26.1-1.44-9.43-1.26-17.33-1.5-19.79-2.19-22.44,5.27-86.42,77.55-86.42s78.74,63.98,76.55,86.42c-.26,2.64,.91,10.69-.81,20.47-2.16,12.32-3.65,23.65-4.15,25.41-4.27,15.03-15.63,54.43-71.59,54.43s-68.62-37.75-72.59-54.43Z"
            :fill="data.skin.value"
          />
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-4-3_Skin_Color_01"
      v-if="data.contour.value === 'type-4'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-9">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,75.74,63.98,73.55,86.42-2.19,22.44-5.54,32.2-7.96,43.88-2.23,10.78-10.86,25.07-23.05,35.61-11.72,10.14-30.31,23.82-42.54,23.82s-30.82-13.69-42.54-23.82c-12.19-10.54-19.9-23.04-22.05-35.61-1.88-11.02-5.77-21.45-7.96-43.88-2.19-22.44.27-86.42,72.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-4-2_Skin_Color_01"
      v-if="data.contour.value === 'type-5'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-8">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,77.74,63.98,75.55,86.42-2.19,22.44-6.26,32.83-7.96,43.88-1.67,10.88-12.86,25.07-25.05,35.61-11.72,10.14-30.31,21.82-42.54,21.82s-30.82-11.69-42.54-21.82c-12.19-10.54-22.9-23.04-25.05-35.61-1.88-11.02-5.77-21.45-7.96-43.88-2.19-22.44,3.27-86.42,75.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-4-1_Skin_Color_01"
      v-if="data.contour.value === 'type-6'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-7">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,79.74,63.98,77.55,86.42-2.19,22.44-4.26,32.83-5.96,43.88-1.67,10.88-16.86,25.07-29.05,35.61-11.72,10.14-30.31,21.82-42.54,21.82s-30.82-11.69-42.54-21.82c-12.19-10.54-26.9-23.04-29.05-35.61-1.88-11.02-3.77-21.45-5.96-43.88-2.19-22.44,5.27-86.42,77.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-3-3_Skin_Color_01"
      v-if="data.contour.value === 'type-7'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-6">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,73.71,63.98,71.55,86.42-2.36,24.44-4.26,32.83-5.96,43.88s-5.86,33.07-18.05,43.61c-11.72,10.14-35.31,15.82-47.54,15.82s-35.82-5.69-47.54-15.82c-12.19-10.54-14.9-31.04-17.05-43.61-1.88-11.02-4.77-21.45-6.96-43.88-2.19-22.44-.73-86.42,71.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-3-2_Skin_Color_01"
      v-if="data.contour.value === 'type-8'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-5">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,77.74,63.98,75.55,86.42-2.19,22.44-6.26,32.83-7.96,43.88s-3.86,30.07-16.05,40.61c-11.72,10.14-39.31,16.82-51.54,16.82s-39.82-6.69-51.54-16.82c-12.19-10.54-13.9-28.04-16.05-40.61-1.88-11.02-5.77-21.45-7.96-43.88-2.19-22.44,3.27-86.42,75.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-3-1_Skin_Color_01"
      v-if="data.contour.value === 'type-9'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-4">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,77.74,63.98,75.55,86.42-2.19,22.44-2.26,32.83-3.96,43.88s-4.86,30.07-17.05,40.61c-11.72,10.14-42.31,16.82-54.54,16.82s-42.82-6.69-54.54-16.82c-12.19-10.54-14.9-28.04-17.05-40.61-1.88-11.02-1.77-21.45-3.96-43.88-2.19-22.44,3.27-86.42,75.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-2-3_Skin_Color_01"
      v-if="data.contour.value === 'type-10'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-3">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,76.74,63.98,74.55,86.42-2.19,22.44-7.26,34.83-8.96,45.88s-9.86,25.07-22.05,35.61c-11.72,10.14-31.31,21.82-43.54,21.82s-32.82-11.69-44.54-21.82c-12.19-10.54-19.9-23.04-22.05-35.61-1.88-11.02-5.77-23.45-7.96-45.88-2.19-22.44,2.27-86.42,74.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-2-2_Skin_Color_01"
      v-if="data.contour.value === 'type-11'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall-2">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,77.74,63.98,75.55,86.42-2.19,22.44-6.26,32.83-7.96,43.88s-4.86,25.07-17.05,35.61c-11.72,10.14-38.31,21.82-50.54,21.82s-38.82-11.69-50.54-21.82c-12.19-10.54-14.9-23.04-17.05-35.61-1.88-11.02-5.77-21.45-7.96-43.88-2.19-22.44,3.27-86.42,75.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-2-1_Skin_Color_01"
      v-if="data.contour.value === 'type-12'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <g id="wall">
            <path
              :fill="data.skin.value"
              d="m159.4,59.83c72.28,0,78.74,63.98,76.55,86.42-2.19,22.44-3.26,32.83-4.96,43.88s-4.86,25.07-17.05,35.61c-11.72,10.14-42.31,21.82-54.54,21.82s-42.82-11.69-54.54-21.82c-12.19-10.54-14.9-23.04-17.05-35.61-1.88-11.02-2.77-21.45-4.96-43.88-2.19-22.44,4.27-86.42,76.55-86.42h0Z"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-1-3_Skin_Color_01"
      v-if="data.contour.value === 'type-13'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <path
            :fill="data.skin.value"
            d="m215.58,215.1c3.79-2.42,6.61-6.1,8.04-10.36,1.73-5.11,2.68-10.14,3.36-14.62,1.69-11.05,5.77-21.45,7.96-43.88s-3.27-86.42-75.55-86.42-77.74,63.98-75.55,86.42c2.19,22.44,6.07,32.86,7.96,43.88.83,4.89,1.76,9.76,3.3,14.51,1.39,4.32,4.27,8.03,8.09,10.47,6.11,3.9,11.59,9.1,17.82,15.34,1.59,1.59,3.11,3.2,4.56,4.81,1.88,2.09,4.15,4.78,6.72,5.91,9.85,4.34,15.86,6.39,27.1,6.39,10.04,0,17.22-2.05,27.06-6.37,2.57-1.13,4.85-3.83,6.72-5.92,1.45-1.62,2.98-3.23,4.57-4.82,6.24-6.24,11.71-11.44,17.83-15.34h0Z"
          />
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-1-2_Skin_Color_01"
      v-if="data.contour.value === 'type-14'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <path
            :fill="data.skin.value"
            d="m235.94,146.24c2.19-22.44-4.27-86.42-76.55-86.42s-79.74,63.98-77.55,86.42c.24,2.46.06,10.35,1.5,19.79,1.89,12.38,2.98,24.1,3.46,26.1,3.12,13.11,11.82,39.21,42.37,49.8,6.96,5.48,17.67,8.99,29.7,8.99s22.31-3.37,29.28-8.66c31.5-10.63,39.43-38.14,42.84-50.13.5-1.76,1.99-13.09,4.15-25.41,1.71-9.78.55-17.83.81-20.47h0Z"
          />
          <path
            fill="#ffebcd"
            d="m139.67,236.05c7.35,7.47,25.33,7.3,34.34,2.98,1.55-.73,3.01-1.7,4.14-2.98l.23.19c-5.64,10.62-26.47,10.89-35.29,4.24-1.5-1.12-2.92-2.52-3.65-4.24l.23-.19h0Z"
          />
          <path
            isolation="isolate"
            opacity=".1"
            d="m139.67,236.05c7.35,7.47,25.33,7.3,34.34,2.98,1.55-.73,3.01-1.7,4.14-2.98l.23.19c-5.64,10.62-26.47,10.89-35.29,4.24-1.5-1.12-2.92-2.52-3.65-4.24l.23-.19h0Z"
          />
        </g>
      </g>
    </g>
    <g
      id="Contour_A-1-1-1_Skin_Color_01"
      v-if="data.contour.value === 'type-15'"
    >
      <g>
        <g>
          <g>
            <ellipse
              :fill="data.skin.value"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              :fill="data.skin.value"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="224.63"
              cy="184.69"
              rx="22.5"
              ry="19.7"
              transform="translate(12.55 383.66) rotate(-82.6)"
            />
            <ellipse
              isolation="isolate"
              opacity=".1"
              cx="94.69"
              cy="184.68"
              rx="19.7"
              ry="22.5"
              transform="translate(-23 13.73) rotate(-7.4)"
            />
            <path
              :fill="data.skin.value"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
            <path
              isolation="isolate"
              opacity=".1"
              d="m171.6,250.9c-1.7-2.2-1.7-5.8-1.2-9.8.8-6.5-4.4-12.2-11.1-12.1-6.7-.1-11.9,5.6-11.1,12.1.5,4,.5,7.6-1.2,9.8-.9,1.1-11.53,8.54-12.83,9.24-23.6,32,71.47,34.4,51.27,0,0,0-13.05-8.24-13.85-9.24Z"
            />
          </g>
          <path
            :fill="data.skin.value"
            d="m159.4,59.83c-72.28,0-77.74,63.98-75.55,86.42,1.32,13.55,3.26,23.45,5.01,31.22.49,2.19.3,4.49-.62,6.53-2.1,4.63-3.24,9.54-3.24,14.64,0,27.57,33.12,47.92,73.98,47.92h.43c.21,0,.43,0,.64-.02,40.36-.39,72.9-20.57,72.9-47.9,0-4.75-.99-9.34-2.83-13.69-.85-2-1.01-4.22-.52-6.33,1.82-7.99,3.97-18.13,5.36-32.37,2.19-22.44-3.27-86.42-75.55-86.42h-.01Z"
          />
        </g>
      </g>
    </g>
  </fragment>
</template>
